import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import VisibilitySensor from 'react-visibility-sensor';
import {logExperiment} from '@homeaway/abacus-client-utils';

export class MvtTestComponent extends Component {
    static propTypes = {
        test: PropTypes.string,
        exposureMinTop: PropTypes.number,
        report: PropTypes.bool,
        reportOnMount: PropTypes.bool,
        children: PropTypes.node,
        partialVisibility: PropTypes.bool
    };

    static defaultProps = {
        exposureMinTop: 10,
        report: true,
        reportOnMount: false,
        partialVisibility: true
    };

    componentDidMount() {
        const {report, reportOnMount} = this.props;
        if (report && reportOnMount) {
            this.logExperiment();
        }
    }

    logExperiment() {
        const {abacus, test} = this.props;
        logExperiment(abacus[test]);
    }

    reportWhenVisible(children) {
        const {test, exposureMinTop, partialVisibility} = this.props;

        return (
            <VisibilitySensor
                partialVisibility={partialVisibility}
                minTopValue={exposureMinTop}
                delayedCall
                onChange={this.onVisibilityChange}
                className={test}
            >
                {children}
            </VisibilitySensor>
        );
    }

    onVisibilityChange = (isVisible) => {
        if (isVisible) {
            this.logExperiment();
        }
    };

    render() {
        const {report, reportOnMount} = this.props;
        const children = (
            <div className={'mvt-container'}>
                {this.props.children}
            </div>
        );

        return report && !reportOnMount
            ? this.reportWhenVisible(children)
            : children;
    }
}

const mapStateToProps = ({abacus}) => ({abacus});

export const MvtTest = connect(mapStateToProps)(MvtTestComponent);
export default MvtTest;
